/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAssociateClientsWithZeroDayResponse } from './ControlAssociateClientsWithZeroDayResponse';
import {
    ControlAssociateClientsWithZeroDayResponseFromJSON,
    ControlAssociateClientsWithZeroDayResponseFromJSONTyped,
    ControlAssociateClientsWithZeroDayResponseToJSON,
} from './ControlAssociateClientsWithZeroDayResponse';
import type { ControlZeroDayAlertUploadJobStatus } from './ControlZeroDayAlertUploadJobStatus';
import {
    ControlZeroDayAlertUploadJobStatusFromJSON,
    ControlZeroDayAlertUploadJobStatusFromJSONTyped,
    ControlZeroDayAlertUploadJobStatusToJSON,
} from './ControlZeroDayAlertUploadJobStatus';

/**
 * 
 * @export
 * @interface ControlGetZeroDayAlertUploadJobResponse
 */
export interface ControlGetZeroDayAlertUploadJobResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    job_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {ControlZeroDayAlertUploadJobStatus}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    status: ControlZeroDayAlertUploadJobStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    started_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    completed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    error_message?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    asset_count?: number;
    /**
     * 
     * @type {ControlAssociateClientsWithZeroDayResponse}
     * @memberof ControlGetZeroDayAlertUploadJobResponse
     */
    result?: ControlAssociateClientsWithZeroDayResponse;
}

/**
 * Check if a given object implements the ControlGetZeroDayAlertUploadJobResponse interface.
 */
export function instanceOfControlGetZeroDayAlertUploadJobResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "job_id" in value;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function ControlGetZeroDayAlertUploadJobResponseFromJSON(json: any): ControlGetZeroDayAlertUploadJobResponse {
    return ControlGetZeroDayAlertUploadJobResponseFromJSONTyped(json, false);
}

export function ControlGetZeroDayAlertUploadJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetZeroDayAlertUploadJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'job_id': json['job_id'],
        'zero_day_alert_id': json['zero_day_alert_id'],
        'status': ControlZeroDayAlertUploadJobStatusFromJSON(json['status']),
        'created_at': json['created_at'],
        'started_at': !exists(json, 'started_at') ? undefined : json['started_at'],
        'completed_at': !exists(json, 'completed_at') ? undefined : json['completed_at'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'asset_count': !exists(json, 'asset_count') ? undefined : json['asset_count'],
        'result': !exists(json, 'result') ? undefined : ControlAssociateClientsWithZeroDayResponseFromJSON(json['result']),
    };
}

export function ControlGetZeroDayAlertUploadJobResponseToJSON(value?: ControlGetZeroDayAlertUploadJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.job_id,
        'zero_day_alert_id': value.zero_day_alert_id,
        'status': ControlZeroDayAlertUploadJobStatusToJSON(value.status),
        'created_at': value.created_at,
        'started_at': value.started_at,
        'completed_at': value.completed_at,
        'error_message': value.error_message,
        'asset_count': value.asset_count,
        'result': ControlAssociateClientsWithZeroDayResponseToJSON(value.result),
    };
}

